(function () {
  var initializedModals = new Set();

  function getProductFormFromTrigger(trigger) {
    var formId = trigger.dataset.productFormId;
    if (formId) {
      var formById = document.getElementById(formId);
      if (formById) return formById;
    }

    var productForm = trigger.closest('product-form');
    if (productForm) {
      return (
        productForm.querySelector('form[data-type="add-to-cart-form"]') ||
        productForm.querySelector('form')
      );
    }

    return trigger.closest('form[data-type="add-to-cart-form"]') || trigger.closest('form');
  }

  function getVariantIdFromForm(form) {
    if (!form) return null;

    var variantInput =
      form.querySelector('input[name="id"].product-variant-id') ||
      form.querySelector('input[name="id"]');

    if (!variantInput || variantInput.disabled) return null;

    return variantInput.value;
  }

  function clearActiveProductForm(modal) {
    modal.activeProductForm = null;
  }

  function initModal(sectionId, modal) {
    var closeEls = modal.querySelectorAll('[data-buy-now-close="' + sectionId + '"]');
    var checkbox = modal.querySelector('.buy-now-modal__checkbox');
    var checkoutBtn = modal.querySelector('[data-buy-now-checkout="' + sectionId + '"]');

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      clearActiveProductForm(modal);
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });

    checkbox.addEventListener('change', function () {
      checkoutBtn.disabled = !this.checked;
    });

    checkoutBtn.addEventListener('click', function () {
      if (!checkbox.checked) return;

      var variantId = getVariantIdFromForm(modal.activeProductForm);
      if (!variantId) return;

      checkoutBtn.classList.add('loading');
      checkoutBtn.disabled = true;
      var spinner = checkoutBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      window.location.href = '/cart/' + variantId + ':1?checkout';
    });
  }

  function initBuyNow(trigger) {
    var sectionId = trigger.dataset.buyNowTrigger;
    if (!sectionId) return;

    var modal = document.getElementById('buy-now-modal-' + sectionId);
    if (!modal) return;

    if (!initializedModals.has(sectionId)) {
      initializedModals.add(sectionId);
      initModal(sectionId, modal);
    }

    trigger.addEventListener('click', function () {
      modal.activeProductForm = getProductFormFromTrigger(trigger);

      var checkbox = modal.querySelector('.buy-now-modal__checkbox');
      var checkoutBtn = modal.querySelector('[data-buy-now-checkout="' + sectionId + '"]');

      checkbox.checked = false;
      checkoutBtn.disabled = true;
      checkoutBtn.classList.remove('loading');
      var spinner = checkoutBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-buy-now-trigger]').forEach(function (el) {
      initBuyNow(el);
    });
  });

  // When navigating back from checkout, the browser restores the page from
  // bfcache with the button still in its loading state — fully reset modal.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.buy-now-modal').forEach(function (modal) {
        modal.setAttribute('hidden', '');
        clearActiveProductForm(modal);
      });
      document.body.style.overflow = '';
      document.querySelectorAll('.buy-now-modal__checkout').forEach(function (btn) {
        btn.classList.remove('loading');
        btn.disabled = false;
        var spinner = btn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      });
    }
  });
})();
